import React, { useEffect, useRef } from 'react';
import { Row, Col, Steps, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { withAlert } from 'react-alert';
import { compose } from 'redux';

import BookingGuidelinesView from './components/BookingGuidelinesView';
import BookingApplicationView from './components/BookingApplicationView';

const ApplicationBasicPage = props => {
	const prevPropsRef = useRef();
	const { resetMeta, resetPage, pageProps } = props;
	const { application } = pageProps;

	// Check prevProps vs currentProps
	useEffect(() => {
		if (pageProps && pageProps.meta) {
			const { meta } = pageProps;

			// Show an alert when the component first mounts
			if (!prevPropsRef.current) {
				const alertOptions = {
					type: meta.code === 200 ? 'success' : 'error',
					...(meta.code === 40399 && { timeout: 0 })
				};
				props.alert.show(meta.message, alertOptions);
				resetMeta();
			}

			// Check if the meta object has changed
			if (prevPropsRef.current && prevPropsRef.current.meta !== meta) {
				const alertOptions = {
					type: meta.code === 200 ? 'success' : 'error',
					...(meta.code === 40399 && { timeout: 0 })
				};
				props.alert.show(meta.message, alertOptions);
				resetMeta();
			}

			// Save the current props for the next update
			prevPropsRef.current = pageProps;
		}
	}, [pageProps, props, resetMeta]);

	const items = [
		{
			title: 'Booking Guidelines'
		},
		{
			title: 'Booking Application'
		},
		{
			title: 'Booking Details'
		}
	];

	const getCurrentStep = () => {
		let step = 0;

		if (!application) {
			step = 0;
		} else if (application.is_draft === true) {
			step = 1;
		} else {
			step = 2;
		}
		return step;
	};

	const getApplicationComponent = () => {
		const step = getCurrentStep();

		if (step === 0) {
			return <BookingGuidelinesView {...props} />;
		} else {
			return <BookingApplicationView
				{...props}
				step={step}
			/>;
		}
	};

	return (
		<React.Fragment>
			<Row>
				<Col
					span={22}
					offset={1}
				>
					<div className="main-content">
						<Row style={{ display: 'flex', marginBottom: 40, alignItems: 'center' }}>
							<div>
								<Button
									icon={<LeftOutlined />}
									style={{ color: '#0088FF', borderColor: '#0088FF', marginBottom: 20 }}
									onClick={() => props.history.push('/applications')}
								>
									My Bookings
								</Button>
							</div>
							<Col
								lg={{ span: 10, offset: 5 }}
								md={{ span: 10, offset: 5 }}
								sm={{ span: 24 }}
								xs={{ span: 24 }}
							>
								<Steps
									current={getCurrentStep()}
									items={items}
									labelPlacement="vertical"
								/>
							</Col>
						</Row>
						<Row>
							<Col
								lg={{ span: 20, offset: 2 }}
								md={{ span: 20, offset: 2 }}
								sm={{ span: 24 }}
								xs={{ span: 24 }}
							>
								<Row
									type="flex"
									justify="center"
									align="middle"
								>
									<Col
										xl={18}
										lg={18}
										md={24}
										sm={24}
										xs={24}
									>
										{getCurrentStep() < 2 && <h3 style={{ color: '#003366', fontWeight: 700, fontSize: 24 }}>Step {getCurrentStep() + 1}</h3>}
									</Col>
								</Row>

								{getApplicationComponent()}
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</React.Fragment>
	);
};
export default compose(withAlert())(ApplicationBasicPage);
